import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAspectRatio43 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6 15L4.5 15L4.5 9L6 9L6 15ZM7.5 16.5L16.5 16.5C17.3284 16.5 18 15.8284 18 15L18 9C18 8.17157 17.3284 7.5 16.5 7.5L7.5 7.5C6.67157 7.5 6 8.17157 6 9L4.5 9C4.5 7.39489 5.76056 6.08421 7.3457 6.00391L7.5 6L16.5 6C18.1569 6 19.5 7.34315 19.5 9L19.5 15C19.5 16.6569 18.1569 18 16.5 18L7.5 18C5.84314 18 4.5 16.6569 4.5 15L6 15C6 15.8284 6.67157 16.5 7.5 16.5Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgAspectRatio43);
export default ForwardRef;
